import * as zod from 'zod';

export const NoGripperState = zod.object({
  kind: zod.literal('NoGripper'),
  isConnected: zod.boolean().optional().default(false),
});

export type NoGripperState = zod.infer<typeof NoGripperState>;
